<template>
  <v-row>
    <v-col cols="6">
      <route-details :route-details="routeDetails" />
    </v-col>
    <v-col
      class="py-0"
      cols="6"
    >
      <route-timeline
        :route-details="routeDetails"
        @route-updated="$emit('route-updated')"
      />
    </v-col>
  </v-row>
</template>

<script>
import RouteDetails from './RouteDetails.vue';
import RouteTimeline from './RouteTimeline.vue';

export default {
  components: { RouteDetails, RouteTimeline },
  props: {
    routeDetails: {
      type: Object,
      required: true,
    },
  },
};
</script>
